import { render, staticRenderFns } from "./AddCourseDialog.vue?vue&type=template&id=3f2ff0e8"
import script from "./AddCourseDialog.vue?vue&type=script&lang=ts"
export * from "./AddCourseDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports